export const NEWS_CATEGORY = [
  'nasional',
  'internasional',
  'ekonomi',
  'olahraga',
  'teknologi',
  'hiburan',
  'gaya-hidup',
];
